module.exports = __webpack_public_path__ + "static/media/journey-electric-orange-email-header.747b9ce3.png";